// App.js
import './App.css';
import React, { useEffect, useRef } from 'react';
import { useDispatch } from 'react-redux';
import { getUser, logout } from './Redux/Actions/actions';
import Login from './Views/Login/Login';
import { Routes, Route, useLocation } from 'react-router-dom';  
import Home from './Views/Home/Home';
import NavBar from './Components/NavBar/NavBar';
import Sidebar from './Components/SideBar/SideBar';
import CreateProperty from './Views/CreateProperty/CreateProperty';
import EditPropertyForm from './Views/EditPropertyForm/EditPropertyForm';
import Aprobar from './Views/Aprobar/Aprobar'
import List from './Views/List/List'
import DetailListView from './Views/DetailListView/DetailListView'
import ListAdmin from './Views/ListAdmin/ListAdmin';
import Sellers from './Views/Sellers/Sellers'
import EditSellerForm from './Components/EditSellerForm/EditSellerForm'
import VisitaForm from './Views/VisitaForm/VisitaForm'
import CardContainerVisitas from './Components/CardVisitasContainer/CardContainerVisitas';
import CloseProperty from './Views/closeProperty/closeProperty';
import Properties from './Views/Properties/Properties'
import GenerarAlquiler from './Views/GenerarAlquiler/GenerarAlquiler';
import PlacaPublicitaria from './Views/PlacaPublicitaria/PlacaTerrenos/PlacaPublicitaria'
import PlacaLuxury from './Views/PlacaPublicitaria/PlacaLuxury/PlacaLuxury';
import PlacaLandingPage from './Views/PlacaPublicitaria/PlacaLandingPage/PlacaLandingPage';
import PlacaCompleta from './Views/PlacaPublicitaria/PlacaCompleta/PlacaCompleta'
import ImageGenerator  from './Views/ImageGenerator/ImageGenerator'
import CardVisitasAllContainer from './Components/CardVisitasAllContainer/CardVisitasAllContainer'
import ACMReport from './Views/ACM/ACMReport/ACMReport'
import Balance from './Views/Balance/Balance';
import ACMLandingPage from './Views/ACM/ACMLandingPage/ACMLandingPage';
import ACMReportTerrenos from './Views/ACM/ACMTerrenosYLotes/ACMReportTerrenos';
import EditPropertyImages from './Components/EditPropertyImages/EditPropertyImages';
import SessionDashboard from './Views/SessionDashboard/SessionDashboard';
import AgentSessionDetail from './Views/SessionDashboard/AgentSessionDetail/AgentSessionDetail';
import EventForm from './Views/EventForm/EventForm';
import EventList from './Views/EventList/EventList';
import CalendarView from './Views/CalendarView/CalendarView';
import Clients from './Views/Clients/Clients';
import RentalManagement from './Views/RentalManagement/RentalManagement';
import ActiveContracts from './Views/RentalManagement/ActiveContracts/ActiveContracts';
import OverduePayments from './Views/RentalManagement/OverduePayments/OverduePayments';
import ExpiringContracts from './Views/RentalManagement/ExpiringContracts/ExpiringContracts';
import PendingPayments from './Views/RentalManagement/PendingPayments/PendingPayments';
import RentalDetail from './Views/RentalDetail/RentalDetail';
import RentalPayments from './Views/RentalPayments/RentalPayments';
import RentalTenants from './Views/RentalTenants/RentalTenants';
import TenantsManagementView from './Views/RentalManagement/TenantsManagementView/TenantsManagementView';
import UpcomingAdjustments from './Views/RentalManagement/UpcomingAdjustments/UpcomingAdjustments';
import ContractSummaryReport from './Views/RentalManagement/ContractSummaryReport/ContractSummaryReport';
import EstadisticasLanding from './Views/Estadisticas/EstadisticasLanding';
import VisitasStats from './Views/Estadisticas/VisitasStats';
import ProductividadStats from './Views/Estadisticas/ProductividadStats';
import ReunionesStats from './Views/Estadisticas/ReunionesStats';
import AnotarVisita from './Views/AnotarVisita/AnotarVisita';
import VisitaExternaForm from './Views/VisitaExterna/VisitaExternaForm';
import OperacionExternaForm from './Views/OperacionExterna/OperacionExternaForm';



function App() {
  const location = useLocation();
  const dispatch = useDispatch();
  const inactivityTimeout = useRef(null);

  // Función para reiniciar el temporizador de inactividad
  const resetInactivityTimeout = () => {
    if (inactivityTimeout.current) {
      clearTimeout(inactivityTimeout.current);
    }
    inactivityTimeout.current = setTimeout(() => {
      dispatch(logout());
      alert('Sesión cerrada por inactividad.');
    }, 1500000); // 25 minutos = 1500000 ms
  };

  useEffect(() => {
    // Recupera la información del usuario del localStorage al cargar la aplicación
    const storedUser = localStorage.getItem('user');
    if (storedUser) {
      const user = JSON.parse(storedUser);
      dispatch(getUser(user.id));
    }

    // Eventos que cuentan como "actividad"
    const events = ['mousemove', 'mousedown', 'keydown', 'touchstart', 'scroll'];
    events.forEach(event =>
      window.addEventListener(event, resetInactivityTimeout)
    );

    // Iniciar el temporizador al montar
    resetInactivityTimeout();

    // Limpiar al desmontar
    return () => {
      events.forEach(event =>
        window.removeEventListener(event, resetInactivityTimeout)
      );
      if (inactivityTimeout.current) {
        clearTimeout(inactivityTimeout.current);
      }
    };
  }, [dispatch]);

  // Prevenir logout en cambios de página y recargas
  useEffect(() => {
    const handleBeforeUnload = (e) => {
      // Detectar si es recarga o navegación interna
      const navEntries = performance.getEntriesByType('navigation');
      const isReload = navEntries.length > 0
        ? navEntries[0].type === 'reload'
        : performance.navigation && performance.navigation.type === 1;

      // NO hacer logout en ningún caso de navegación o recarga
      // Solo el temporizador de inactividad debe cerrar la sesión
      
      // Si quieres mostrar mensaje de confirmación al cerrar pestaña:
      // e.preventDefault();
      // e.returnValue = '';
    };
    window.addEventListener('beforeunload', handleBeforeUnload);
    return () => {
      window.removeEventListener('beforeunload', handleBeforeUnload);
    };
  }, [dispatch]);

  return (
    <div className="App">
      {location.pathname !== "/" && <NavBar />}
      <div className="content">
        {location.pathname !== "/" && <Sidebar />}
        <div className="main">
          <Routes>
            <Route path='/' element={<Login />} />
            <Route path='/home' element={<Home />} />
            <Route path='/create' element={<CreateProperty />} />
            <Route path='/detalles/:id' element={<EditPropertyForm />} />
            <Route path='/aprobar' element={<Aprobar />} />
            <Route path='/lista' element={<List />} />
            <Route path='/lista-administrador' element={<ListAdmin />} />
            <Route path='/lista/detail/:id' element={<DetailListView />} />
            <Route path='/usuarios' element={<Sellers />} />
            <Route path="/edit-seller/:id" element={<EditSellerForm />} />
            <Route path="/visita/:id" element={<VisitaForm />} />
            <Route path="/historial/visitas/:id" element={<CardContainerVisitas />} />
            <Route path="/visitas" element={<CardVisitasAllContainer />} />
            <Route path="/anotar-visita" element={<AnotarVisita />} />
            <Route path="/visita-externa/nueva" element={<VisitaExternaForm />} />
            <Route path="/cierre-property/:id" element={<CloseProperty />} />
            <Route path="/properties" element={<Properties />} />
            <Route path="/generar-alquiler/:propertyId" element={<GenerarAlquiler />} />
            <Route path="/placas" element={<PlacaLandingPage />} />
            <Route path="/placas/terrenos" element={<PlacaPublicitaria />} />
            <Route path="/placas/inmueble" element={<PlacaCompleta />} />
            <Route path="/placas/luxury" element={<PlacaLuxury />} />
            <Route path="/image" element={<ImageGenerator />} />
            <Route path="/acm" element={<ACMLandingPage />} />
            <Route path="/acm-inmuebles" element={<ACMReport />} />
            <Route path="/acm-terrenos" element={<ACMReportTerrenos />} />
            <Route path="/balance" element={<Balance />} />
            <Route path="/edit-images/:id" element={<EditPropertyImages />} />
            <Route path="/dashboard-sesiones" element={<SessionDashboard />} />
            <Route path="/dashboard-sesiones/:id" element={<AgentSessionDetail />} />
            <Route path="/eventos/crear" element={<EventForm />} />
            <Route path="/eventos/editar/:id" element={<EventForm />} />
            <Route path="/eventos" element={<EventList />} />
            <Route path="/calendario" element={<CalendarView />} />
            <Route path="/clientes" element={<Clients />} />
            <Route path="/alquileres" element={<RentalManagement />} />
            <Route path="/alquileres/inquilinos" element={<TenantsManagementView />} />
            <Route path="/alquileres/contratos" element={<ActiveContracts />} />
            <Route path="/alquileres/vencidos" element={<OverduePayments />} />
            <Route path="/alquileres/pendientes-mes" element={<PendingPayments />} />
            <Route path="/alquileres/por-vencer" element={<ExpiringContracts />} />
            <Route path="/alquileres/ajustes" element={<UpcomingAdjustments />} />
            <Route path="/alquileres/reportes" element={<ContractSummaryReport />} />
            <Route path="/alquileres/contrato/:contractId" element={<RentalDetail />} />
            <Route path="/alquileres/contrato/:contractId/pagos" element={<RentalPayments />} />
            <Route path="/alquileres/contrato/:contractId/inquilinos" element={<RentalTenants />} />
            <Route path="/estadisticas" element={<EstadisticasLanding />} />
            <Route path="/estadisticas/visitas" element={<VisitasStats />} />
            <Route path="/estadisticas/productividad" element={<ProductividadStats />} />
            <Route path="/estadisticas/reuniones" element={<ReunionesStats />} />
            <Route path="/operacion-externa/nueva" element={<OperacionExternaForm />} />
          </Routes>
        </div>
      </div>
    </div>
  );
}

export default App;
